/********************************************
 * Video Block
 ********************************************/

function fnVideoBlock(i, oSection) {

    var oSection = $(oSection),
        oBtn = $('.video-play-icon', oSection),
        oPoster = $('.video-poster', oSection),
        oVideo = $('.video', oSection);

    oBtn.on('click', function () {

        oSection.addClass('is-active');
        oBtn.fadeOut(300);
        oPoster.fadeOut(300);
        oVideo[0].play();

        return false;
    });

    oVideo.on('click', function () {

        oSection.removeClass('is-active');
        oBtn.fadeIn(300);
        oPoster.fadeIn(300);
        oVideo[0].pause();

        return false;
    });


}


// END OF DOCUMENT
